import { Component } from '@angular/core';

import { PickupForScheduleComponent } from '../forSchedule/pickup-for-schedule.shared.component';

@Component({
    selector: 'shared-pickup-for-schedule-mock',
    templateUrl: './pickup-for-schedule-mock.shared.component.html',
    styleUrls: ['./pickup-for-schedule-mock.shared.component.scss']
})
export class PickupForScheduleMockComponent extends PickupForScheduleComponent {
    public period: OLO.Components.DropDown.IDropDownOption = {
        Id: 1,
        Name: 'Today'
    };

    public pickup: OLO.Components.DropDown.IDropDownOption = {
        Id: 1,
        Name: 'ASAP'
    };

    public get periods(): OLO.Components.DropDown.IDropDownOption[] {
        return [
            this.period
        ];
    }

    public get pickups(): OLO.Components.DropDown.IDropDownOption[] {
        return [
            this.pickup
        ];
    }
}
